import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { mealPlanId: Number, date: String, mealTypeId: Number }

  dragstart(event) {
    event.dataTransfer.effectAllowed = "move"
    const nameEl = this.element.querySelector(".font-medium")
    const recipeName = nameEl ? nameEl.textContent.trim() : ""

    event.dataTransfer.setData("application/json", JSON.stringify({
      mealPlanId: this.mealPlanIdValue,
      sourceDate: this.dateValue,
      sourceMealTypeId: this.mealTypeIdValue,
      recipeName
    }))

    this.element.classList.add("opacity-50", "scale-95")
    document.querySelectorAll("[data-drop-zone]").forEach(zone => {
      zone.classList.add("transition-colors")
    })
  }

  dragend(_event) {
    this.element.classList.remove("opacity-50", "scale-95")
    document.querySelectorAll("[data-drop-zone]").forEach(zone => {
      zone.classList.remove("border-terracotta", "border-2", "border-dashed", "bg-terracotta/10")
    })
  }
}
